module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido-05b3f3d6d633e52fb74bd64537765227.webp";